import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { ProductInterestModel } from 'src/models';

const productInterestAdapter: AdapterFunc<GQL.ProductInterestModel, ProductInterestModel> = (
  input,
) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default productInterestAdapter;
